<template>
  <span>
    <a class="sf-block sf-a sf-tab-item" @click="openModal">
      {{ text }}
    </a>
    <BudgetSetImportsModal
      v-if="isModalOpen"
      :allowed-filename-extensions="allowedFilenameExtensions"
      :analytical-dimensions-selected="analyticalDimensionsSelected"
      :budget-set-id="budgetSetId"
      :budget-set-name="budgetSetName"
      :company="company"
      :entries-filter="entriesFilter"
      :first-period="firstPeriod"
      :has-analytical-dimensions="hasAnalyticalDimensions"
      :last-period="lastPeriod"
      @close="closeModal"
    />
  </span>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import BudgetSetImportsModal from './budget-set-imports-modal.vue'

defineOptions({
  name: 'BudgetSetImportsButton',
})

interface Props {
  allowedFilenameExtensions: string
  analyticalDimensionsSelected: string
  budgetSetId: number
  budgetSetName: string
  company: {
    firmId: string
    id: string
  }
  entriesFilter: Record<string, string[]>
  firstPeriod: string
  hasAnalyticalDimensions: boolean
  lastPeriod: string
  text: string
}

defineProps<Props>()

const isModalOpen = ref(false)

const openModal = (): void => {
  isModalOpen.value = true
}

const closeModal = (): void => {
  isModalOpen.value = false
}
</script>
